// extracted by mini-css-extract-plugin
export default {"forms":"form_forms__+Z+GE"};